import React, { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import FloatingLabelInput from "../components/form_elements/FloatingLabelInput";
import { IconAlertSmall } from "@tabler/icons-react";
import Modal from "../components/modals/Modal";

const KozgyogyKerdes = () => {
	const { order, updateOrder } = useOrder();
	const navigate = useStepNavigate();
	const { saveOrder, loading: orderSaveLoading } = useOrderSave();
	const [showModal, setShowModal] = useState(false);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		let newValue = value;
		if (name === "partner_charitycare_num") {
			if (value.length > 8) return;
			newValue = value.replace(/\D/g, "").slice(0, 8);
		}
		updateOrder({
			...order,
			partner: {
				...order.partner,
				[name]: newValue,
			},
		});
	};

	const handlePermanentToggle = (e) => {
		const checked = e.target.checked;

		updateOrder({
			...order,
			partner: {
				...order.partner,
				partner_charity_validdate: checked ? "3000-01-01" : "",
			},
		});
	};

	const handleSubmit = async () => {
		try {
			const today = new Date().toISOString().slice(0, 10);
			if (order.partner.partner_charity_validdate < today) {
				setShowModal(true);
				return;
			}
			const result = await saveOrder(order);

			if (result.success) {
				if (order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
					navigate("/BetetTartozek");
				} else {
					navigate("/Mennyiseg");
				}
			}
		} catch (error) {
			console.error("Hiba a rendelés mentésekor:", error);
		}
	};

	const handleModalYes = () => {
		const updatedOrder = {
			...order,
			partner: {
				...order.partner,
				partner_charitycare_num: "",
				partner_charity_validdate: "",
			},
			hmeliorder: {
				...order.hmeliorder,
				hmeliorder_specaidtype: 1,
				hmeliorder_specaidtype_national: "Normatív",
			},
		};
		updateOrder(updatedOrder);

		setShowModal(false);
		navigate("/Mennyiseg");
	};

	return (
		<TablerLayout title="Közgyógyellátási igazolvány adatok">
			<div
				className="row justify-content-center"
				style={{ filter: showModal ? "blur(3px)" : "none" }}
			>
				<div className="col-md-10 mb-4">
					<div className="card-body">
						<div className="mb-3">
							<FloatingLabelInput
								type="text"
								label="Közgyógyellátási igazolvány száma"
								id="partner_charitycare_num"
								name="partner_charitycare_num"
								value={order.partner.partner_charitycare_num || ""}
								onChange={handleInputChange}
								maxLength={8}
								required
							/>
						</div>
						<div className="mb-3">
							<FloatingLabelInput
								type="date"
								label="Közgyógyellátási igazolvány lejárata"
								id="partner_charity_validdate"
								name="partner_charity_validdate"
								value={order.partner.partner_charity_validdate || ""}
								onChange={handleInputChange}
								required
								disabled={order.partner.partner_charity_validdate === "3000-01-01"}
							/>
						</div>
						<div
							className="mb-3 form-check d-flex align-items-center"
							style={{ minHeight: "44px", paddingLeft: "2.0rem" }}
						>
							<input
								className="form-check-input"
								type="checkbox"
								id="charity_valid_until_revoked"
								checked={order.partner.partner_charity_validdate === "3000-01-01"}
								onChange={handlePermanentToggle}
								style={{
									width: "1.5rem",
									height: "1.5rem",
									marginTop: "0.1rem",
									marginLeft: "-2.0rem",
									cursor: "pointer",
								}}
							/>
							<label
								className="form-check-label"
								htmlFor="charity_valid_until_revoked"
								style={{ fontSize: "1rem", paddingLeft: "0.4rem", cursor: "pointer" }}
							>
								Visszavonásig érvényes
							</label>
						</div>
					</div>
				</div>
				<div className="d-flex justify-content-between mt-4">
					<StepperNavButton side="left" label="Vissza" onClick={() => navigate("/AdatVenyes")} />
					<StepperNavButton
						side="right"
						label="Tovább"
						onClick={handleSubmit}
						disabled={(order.partner.partner_charitycare_num.length === 8 && order.partner.partner_charity_validdate ? false : true) || orderSaveLoading}
					/>
				</div>
			</div>

			<Modal
				isOpen={showModal}
				onClose={() => setShowModal(false)}
				onConfirm={handleModalYes}
				title="Lejárt igazolvány"
				type="warning"
				confirmText="Igen"
				secondaryText="Nem"
				confirmClass="btn btn-primary"
				secondaryClass="btn btn-danger"
				showSecondary={true}
				showCancel={true}
				icon={<IconAlertSmall size={70} stroke={2} className="text-warning" />}
			>
				<h4>
					A közgyógyellátási igazolvány lejárata korábbi, mint a megrendelés dátuma.
					<br />
				</h4>
				<h5>Kívánja normatív vényként rögzíteni a rendelést inkább?</h5>
			</Modal>
		</TablerLayout>
	);
};

export default KozgyogyKerdes;
